import { e } from "./engine-user-agent.js";
var s = /web0s(?!.*chrome)/i.test(e);
export { s as e };